<template>
  <div class="home">
    <HeroSection />
    <FeatureSection />
    <AgentSection />
    <ContactSection />
    <DownloadSection />
  </div>
</template>

<script>
import HeroSection from "@/components/HeroSection.vue";
import FeatureSection from "@/components/FeatureSection.vue";
import AgentSection from "@/components/AgentSection.vue";
import ContactSection from "@/components/ContactSection.vue";
import DownloadSection from "@/components/DownloadSection.vue";

export default {
  name: "HomeView",
  components: {
    HeroSection,
    FeatureSection,
    AgentSection,
    ContactSection,
    DownloadSection
  }
};
</script>
